import { createIcon } from '../createIcon';
import { ReactComponent as IconUserTag } from '../svg/user-tag.svg';

export default createIcon(IconUserTag);
